import React, { useState, useEffect, Fragment, useRef } from 'react'
import { Table, Modal, message, Divider, Button, Switch, Popconfirm, Form,Col,DatePicker,Input } from "antd";
import { DownloadOutlined, PlusOutlined, EditFilled, DeleteOutlined } from '@ant-design/icons';
import InspectionApi from '@api/inspectionnew'
import { stationApi, } from "@api/newApi";

import SearchForm from '@components/SearchForm'
import HandleButton from '@components/HandleButton'
import Title from '@/components/Title'
import { connect } from 'react-redux'
import moment from 'moment';
import { setStateSearchParams } from '@store/actions/common'
import { getStationData, identifierData } from '@utils/common'
import AddModel from './add'
import '../style.scss'

//  0-待处理,1-处理中,2-已关闭, 3-已转工单
const StatusData = ['待处理', '处理中', '已完成']
// 巡检周期
const cycleData = ['天','周','月','季度','指定日期']
const OrderCom = (props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false)
  const [loadBtn, setLoadBtn] = useState(false)
  const [data, setData] = useState([]) // 表格数据
  const [deleteVisible, setDelVisible] = useState(false)
  const [editVisible, setEditVisible] = useState(false)
  const [editTitle] = useState('新增缺陷单')
  const [rowParams, setRowParams] = useState()
  const [acceptVisible, setAcceptVisible] = useState(false) 
  const [checkacceptVisible, setCheckacceptVisible] = useState(false)
  // 查询参数
  // 搜索相关参数
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
    name: ''
  })
  const [total, setTotal] = useState(0)


  // 搜索
  const [inputList] = useState([{
    label: '名称:',
    name: "planname",
    message: "请输入名称",
    span: 8,
    labelCol: 6
  },{
    label: '执行人:',
    name: "executor",
    message: "请输入执行人",
    span: 8,
    labelCol: 6
  }])
  
  const [selectList, setSelectList] = useState()

  const [stationData, setStationData] = useState()


  useEffect(() => {
    getStationList()
    return () => { }
  }, [])
  // 获取厂站列表
  const getStationList = () => {
    const data = getStationData(props.userInfo.stationIds ? props.userInfo.stationIds : '-1', props.userInfo.stationAliasName)
    setSelectList([
      {
        attr: { allowClear: true },
        label: '厂站:',
        name: "stationId",
        message: "请选择厂站",
        options: data,
        span: 8,
        labelCol: 6
      },
      {
        attr: { allowClear: true },
        label: '周期:',
        name: "cycle",
        message: "请选择周期",
        options: cycleData.map ( (item,index) => { return { title: item,value: index, checked: false } } ),
        span: 8,
        labelCol: 6
      }
      // {
      //   attr: { allowClear: true },
      //   label: '状态:',
      //   name: "status",
      //   message: "请选择状态",
      //   options: StatusData.map((v, i) => { return { title: v, value: i, checked: false } }),
      //   span: 8,
      //   labelCol: 6
      // },
    ])
    setStationData(data)
  }

  useEffect(() => {
    listByRole()
    return () => { }
  }, [searchParams])

  const listByRole = () => {
    setLoading(true)
    // const statinIds = userInfo.stationIds ? userInfo.stationIds.split(",") : []
    InspectionApi.upkeepPlan({ ...searchParams, status: searchParams.status * 1 }).then(res => {
      setLoading(false)
      if (res.status == 0 && res.data) {
        res.data.data.unshift({
          id: '99',
          planName: '抽水泵保养',
          stationAliasName: '牛滩',
          notifierUserName: '张三',
          cycleData: '每月第五天',
          startAt: '2020-08-02',
          endAt: '2022-12-12'
        })

        setData(res.data.data || [])
        setTotal(res.data.total)
      }
    })
  }

  // 分页
  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    }
    setSearchParams(params)
  };

  /**
   * 搜索
   * @param params
   */
  const search = (paramsObj) => {
    console.log(paramsObj, 'paramsObj')
    let params = {
      ...paramsObj,
      pageNum: 1,
      pageSize: 10,
      stationId: paramsObj.stationId && paramsObj.stationId * 1
    }
    setSearchParams(params)
  }

  /**
  * 删除规则
  */
  const deletes = (id) => {
    setLoadBtn(true)
    InspectionApi.delete(id).then(res => {
      setLoadBtn(false)
      if (res.status == 0) {
        setDelVisible(false)
        setRowParams(null)
        listByRole()
        message.success("删除成功！")
      }
    }).catch(err => {
      setLoadBtn(false)
    })
  }

  const cancel = () => {
    setDelVisible(false)
    setAcceptVisible(false)
    setCheckacceptVisible(false)
    form.resetFields();
    // setParams({})
  }
  // 改变状态
  const handleConfirm = (info) => {
    InspectionApi.defectLevelDel({ id: info.id}).then(res => {
      if (res.status == '0') {
        message.success('删除成功')
        listByRole()
      }
    })
  }
  // 关闭工单
  const handleClose = (id) => {
    InspectionApi.closeDefectOrder(id).then(res => {
      if (res.status == 0) {
        message.success('关闭成功')
        listByRole()
      }
    })
  }

    // 接受工单
    const accept = () => {
      form.validateFields().then(values => {
        if(!values){
          return;
        }
        InspectionApi.defectAccept({id:rowParams.id,planCloseTime:values.planCloseTime}).then(res => {
          if (res.status == 0) {
            message.success('接受成功')
            listByRole()
            setAcceptVisible(false)
          }
        })
      })
      
    }
    //验收
   const checkaccept = () => {
    form.validateFields().then(values => {
      if(!values){
        return;
      }
      InspectionApi.checkAccept({id:rowParams.id,deffectRemark:values.deffectRemark}).then(res => {
        if (res.status == 0) {
          message.success('接受成功')
          listByRole()
          setAcceptVisible(false)
        }
      })
    })
   }

  // 转工单
  const handleOrder = (record) => {
    console.log('123123123')
    setEditVisible(true)
    setRowParams(record)
  }


  const btnList = [{
    title: "新增",
    type: 'primary',
    icon: <PlusOutlined />,
    onClick: () => {
      setRowParams(null)
      setEditVisible(true)      
    }
  }]

  const columns = [
    {
      title: '名称',
      dataIndex: 'planName',
      align: 'center',
      key: 'planName',
      ellipsis: true
    },
    {
      title: '所属厂站',
      dataIndex: 'stationAliasName',
      align: 'center',
      width: 100,
      key: 'stationAliasName',
    },
    // {
    //   title: '缺陷等级名称',
    //   dataIndex: 'levelName',
    //   align: 'center',
    //   key: 'levelName',
    // },
    // {
    //   title: '缺陷内容',
    //   dataIndex: 'remark',
    //   align: 'center',
    //   key: 'remark',
    //   width: 200,
    //   ellipsis: true
    // },
    // {
    //   title: '状态',
    //   dataIndex: 'handleStatus',
    //   align: 'center',
    //   key: 'handleStatus',
    //   render: (obj, record) => {
    //     return <span> {StatusData[obj] || '-'}</span>
    //   }
    // },

    {
      title: '执行人',
      dataIndex: 'notifierUserName',
      align: 'center',
      key: 'notifierUserName',
    },
    {
      title: '周期',
      dataIndex: 'cycleData',
      align: 'center',
      key: 'cycleData',
    },
    {
      title: '开始时间',
      dataIndex: 'startAt',
      align: 'center',
      key: 'startAt',
      render: (obj) => {
        if (obj) {
          return (
            moment(obj).format('YYYY-MM-DD HH:mm:ss')
          )
        }
      }
    },
    {
      title: '结束时间',
      dataIndex: 'endAt',
      align: 'center',
      key: 'endAt',
      render: (obj) => {
        if (obj) {
          return (
            moment(obj).format('YYYY-MM-DD HH:mm:ss')
          )
        }
      }
    }
    // {
    //   title: '创建时间',
    //   dataIndex: 'createAt',
    //   align: 'center',
    //   key: 'createAt',
    //   render: (obj) => {
    //     if (obj) {
    //       return (
    //         moment(obj).format('YYYY-MM-DD HH:mm:ss')
    //       )
    //     }
    //   }
    // },

    // {
    //   title: '修改时间',
    //   dataIndex: 'updateAt',
    //   align: 'center',
    //   key: 'updateAt',
    //   render: (obj) => {
    //     if (obj) {
    //       return (
    //         moment(obj).format('YYYY-MM-DD HH:mm:ss')
    //       )
    //     }
    //   }
    // },

    // {
    //   title: '操作',
    //   key: 'operation',
    //   width: '200px',
    //   align: 'center',
    //   fixed: 'right',
    //   render: (obj, record) => {
    //     return (
    //       <>
    //       <Popconfirm
    //           title={`确定要删除该缺陷等级吗`}
    //           onConfirm={() => handleConfirm(record)}
    //           // onCancel={cancel}
    //           okText="确定"
    //           cancelText="取消"
    //         >
    //           <Button size='small' type="primary">删除</Button>
    //         </Popconfirm>
            
    //       </>
    //     )
    //   }
    // }
  ]
  return (
    <div className='baseContent boundary'>
      <div className='title'>
        {/* <Title title="站点列表" style={{ marginLeft: '24px' }}></Title> */}
        <div style={{ marginLeft: '24px' }}>
          <SearchForm span={6} inputList={inputList} selectList={selectList} onSearch={search} />
        </div>
        <HandleButton btnList={btnList} btnStyle={{ padding: '0 24px 20px', textAlign: 'right' }} />
        <div >
          <Table
            className='Table'
            scroll={{ x: columns.length * 200 }}
            columns={columns}
            dataSource={data}
            rowKey={record => record.id}
            pagination={{
              current: searchParams.pageNum,
              pageSize: searchParams.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: total => `共${total}条数据`,
              total: total
            }}
            onChange={handleTableChange}
            loading={loading}
          />
        </div>
        {
          acceptVisible &&
          <Modal 
            title='接收缺陷单'
            width={600}
            open={acceptVisible}
            onCancel={cancel}
            confirmLoading={loadBtn}
            onOk={accept}>
            <Form form={form}
              layout="horizontal"
            >
              <Col span={18}>
            <Form.Item 
                label='计划关闭时间'
                name='planCloseTime'
                rules={[{ required: true, message: '请选择计划关闭时间!' }]}
              >
                <DatePicker
                  format="YYYY-MM-DD HH:mm:ss"
                  // disabledDate={disabledDate}
                  // disabledTime={disabledDateTime}
                  showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
                />
              </Form.Item>
          </Col>
            </Form>
          </Modal>
        }
        {
          checkacceptVisible &&
          <Modal 
            title='验收缺陷单'
            width={600}
            open={checkacceptVisible}
            onCancel={cancel}
            confirmLoading={loadBtn}
            onOk={checkaccept}>
            <Form form={form}
              layout="horizontal"
            >
              <Col span={18}>
            <Form.Item label='缺陷描述' name="deffectRemark" rules={[{ required: true, message: '请输入缺陷描述!' }]}>
              <Input.TextArea row={4} placeholder={'请输入缺陷描述'} />
            </Form.Item>
          </Col>
            </Form>
          </Modal>
        }
        {
          deleteVisible &&
          <Modal
            title='详情'
            width={600}
            open={deleteVisible}
            onCancel={cancel}
            confirmLoading={loadBtn}
            onOk={cancel}>
            <Form
              layout="horizontal"
            >
              <Form.Item label='任务名称'>
                {rowParams.title}
              </Form.Item>
              <Form.Item label='所属场站'>
                {rowParams.stationName}
              </Form.Item>
              <Form.Item label='缺陷状态'>
                {StatusData[rowParams.status]}
              </Form.Item>
              <Form.Item label='缺陷内容'>
                {rowParams.content}
              </Form.Item>
              <Form.Item label='创建时间'>
                {rowParams.createAt}
              </Form.Item>
              <Form.Item label='更新时间'>
                {rowParams.updateAt}
              </Form.Item>
            </Form>
          </Modal>
        }
        {editVisible && <AddModel stationData={stationData} visible={editVisible} title={editTitle} formData={rowParams} cancel={(bool) => { setEditVisible(false); bool && listByRole() }} />}
      </div>
    </div >
  )
}

const mapStateToProps = state => {
  return {
    ...state.Common
  }
};

export default connect(mapStateToProps)(OrderCom)
